'use strict';

function handlePasteOTP (e) {
    var clipboardData = e.clipboardData || window.ClipboardData || e.originalEvent.clipboardData;
    var pastedData = clipboardData.getData('Text');
    var arrayOfText = pastedData.toString().split('');

    /* for number only */
    if (isNaN(parseInt(pastedData, 10))) {
        e.preventDefault();
        return;
    }
    for (var i = 0; i < arrayOfText.length; i++) {
        if (i >= 0) {
            document.querySelector(`[name="digit${i + 1}"]`).value = arrayOfText[i];
        } else {
            return;
        }
    }
    e.preventDefault();
}

module.exports = {
    timerEvent: function () {
        clearInterval(window.downloadTimer);
        var isVisible = $('.resendCounter').css('color');
        if (isVisible !== '#f00') {
            sessionStorage.setItem('otpCounter', 1);
            var timeleft = 60;
            $('.resendButton').css('display', 'none');
            $('.resendCounter').css('display', 'block');
            window.downloadTimer = setInterval(() => {
                timeleft--;
                $('.resendCounter').html(`Resend OTP in ${timeleft} sec`);
                if (timeleft <= 0) {
                    clearInterval(window.downloadTimer);
                    $('.resendCounter').html('').css('display', 'none');
                    $('.resendButton').css('display', 'block');
                }
            }, 1000);
        }
    },
    multiTimerEvent: function () {
        clearInterval(window.downloadTimer);
        var isVisible = $('.resendCounter').css('color');
        if (isVisible !== '#f00') {
            var timeleft;
            if (sessionStorage.getItem('otpCounter') === "3") {
                timeleft = 600;
            } else {
                timeleft = 60;
            }
            $('.resendButton').css('display', 'none');
            window.downloadTimer = setInterval(() => {
                timeleft--;
                var timeleftMessage;
                if (sessionStorage.getItem('otpCounter') === "3") {
                    function secondsToTime(e){
                        const h = Math.floor(e / 3600).toString().padStart(2,'0'),
                                m = Math.floor(e % 3600 / 60).toString().padStart(2,'0'),
                                s = Math.floor(e % 60).toString().padStart(2,'0');
                        
                        return m + 'min ' + s + 'sec';
                    }
                    timeleftMessage = `Resend OTP in ${secondsToTime(timeleft)}`;
                } else {
                    timeleftMessage = `Resend OTP in ${timeleft} sec`;
                }
                if (timeleft >= 0) $('.resendCounter').html(timeleftMessage);
                if (timeleft <= 0) {
                    clearInterval(window.downloadTimer);
                    $('.resendCounter')
                        .html('')
                        .css('display', 'none');
                    $('.resendButton').css('display', 'block');
                }
            }, 1000);
            $('.resendCounter').css('display', 'block');
        }
    },
    handleAutoFillOTP: function () {
        if ('OTPCredential' in window) {
            try {
                if (navigator.credentials) {
                    const signal = new AbortController();
                    setTimeout(() => {
                        signal.abort();
                    }, 1 * 60 * 1000);
                    try {
                        navigator.credentials
                            .get({ abort: signal, otp: { transport: ['sms'] } })
                            .then(content => {
                                if (content && content.code) {
                                    var otpCode = content.code;
                                    var otpArray = otpCode.toString().split('');
    
                                    for (var i = 0; i < otpArray.length; i++) {
                                        if (i >= 0) {
                                            document.querySelector(`[name="digit${i + 1}"]`).value = otpArray[i];
                                        } else {
                                            return;
                                        }
                                    }
                                }
                            })
                            .catch(e => console.log(e));
                    } catch (e) {
                        return;
                    }
                }
            } catch (err) {
                console.log(err);
            }
        }
    },
    otpInputs: function () {
        var otpInputs = $(document).find('.otp-inputs');
        otpInputs.each(function () {
            var $input = $(this).find('.otpInput');
            $input.val('');
            $input.keydown(function (ev) {
                var otpVal = $(this).val();
                if (ev.keyCode === 37) {
                    $(this).prev().focus();
                    ev.preventDefault();
                } else if (ev.keyCode === 39) {
                    $(this).next().focus();
                    ev.preventDefault();
                } else if (otpVal.length === 1 && ev.keyCode !== 8 && ev.keyCode !== 46) {
                    var otpNextNumber = $(this).next();
                    if (otpNextNumber.length === 1 && otpNextNumber.val().length === 0) {
                        otpNextNumber.focus();
                    }
                } else if (otpVal.length === 0 && ev.keyCode === 8) {
                    $(this).prev().val('');
                    $(this).prev().focus();
                } else if (otpVal.length === 1 && ev.keyCode === 8) {
                    $(this).val('');
                } else if (otpVal.length === 0 && ev.keyCode === 46) {
                    var nextInput = $(this).next();
                    nextInput.val('');
                    while (nextInput.next().length > 0) {
                        nextInput.val(nextInput.next().val());
                        nextInput = nextInput.next();
                        if (nextInput.next().length === 0) {
                            nextInput.val('');
                            break;
                        }
                    }
                }
            }).focus(function () {
                $(this).select();
                var otpVal = $(this).prev().val();
                if (otpVal === '') {
                    $(this).prev().focus();
                } else if ($(this).next().val()) {
                    $(this).next().focus();
                }
            }).keyup(function (ev) {
                // eslint-disable-next-line no-unused-vars
                var otpCodeTemp = '';
                $input.each(function () {
                    otpCodeTemp += $(this).val();
                });
                if ($(this).val().length === 1 && ev.keyCode !== 37 && ev.keyCode !== 39) {
                    $(this).next().focus();
                    ev.preventDefault();
                }
            });
            $input.on('paste', (e) => {
                handlePasteOTP(e);
            });
        });
    }
};